import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { Repository } from 'typeorm';
import { RackZoneDtoActive } from './dto/rack-zone-mapping-active.dto';
import { RackZoneMappingDtO } from './dto/rack-zone-mapping-dto';
import { RackZoneMappingAdapter } from './rack-zone-mapping-adapter'
import { RackZoneMapping } from './rack-zone-mapping-entity';
import { RackZoneMappingRepository } from './rack-zone-mapping-repository';
import { RackZoneMappingResponseModel, RackZoneMappingDTo, AllRackZoneMapResponseModel, AllRackZoneMappingDto, RackDropDownDto, ZoneDropDownDto, EndCustomersData, RackZoneEmpData, RackZoneMapResponseModel, RackZoneEmpMapResponseModel, RackZonemapResponse } from '@gtpl/shared-models/masters'
import { RackZoneEndCustResponse } from './dto/rack-zone-end-cust.response';
@Injectable()
export class RackZoneMappingService {
    constructor(

        private repository: RackZoneMappingRepository,
        private rackzoneAdapter: RackZoneMappingAdapter,
    ) { }

    async CreateRackZone(details: RackZoneMappingDtO, isUpdate: boolean): Promise<RackZoneMappingResponseModel> {
        //this section will be executed while creating a new user only
        console.log(details);
        if (!isUpdate) {
            const rackZoneEntity = await this.getRackZone(details.zoneId,details.rackId,details.endCustomerId);
            if (rackZoneEntity) {
                
  
                throw new ErrorResponse(11104, 'RackZone  already exists');
            }
        }
        const convertedEntity = await this.rackzoneAdapter.convertDtoToEntity(details,isUpdate);
        console.log(convertedEntity);
        const response = await this.repository.save(convertedEntity);
        if (response) {
            const data = new RackZoneMappingDTo(response.rackInfo.rackId, response.zoneInfo.zoneId, response.endCustomerInfo.endCustomerId, response.createdUser, response.updatedUser, response.isActive);
            return new RackZoneMappingResponseModel(true, 2234, 'RackZone Details Created Successfully',data )
        } else {
            throw new ErrorResponse(9999, 'Failed To Create');
        }
    }

    async getAllRackZone(): Promise<AllRackZoneMapResponseModel> {
        const responseDate = await this.repository.find({relations:['rackInfo', 'zoneInfo','endCustomerInfo']});

        const rackZoneDetails: AllRackZoneMappingDto[] = [];
        if (responseDate.length > 0) {
            responseDate.forEach((rackZone) => {
                const rackZoneData = new AllRackZoneMappingDto((rackZone.rackInfo)?rackZone.rackInfo.rackId:0,rackZone.zoneInfo.zoneId,(rackZone.rackInfo)?rackZone.rackInfo.rackCode:'', rackZone.zoneInfo.zoneName, rackZone.endCustomerInfo.endCustomerId, rackZone.endCustomerInfo.endCustomerName, rackZone.isActive, rackZone.versionFlag, rackZone.rackZoneMappingId);
                rackZoneDetails.push(rackZoneData);
            })
            return new AllRackZoneMapResponseModel(true, 2234, 'RackZone Details Retrived Successfully', rackZoneDetails)
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }


    async getRecordByRackZoneMapId(id: number): Promise<RackZoneEmpMapResponseModel> {
        const responseData = await this.repository.findOne({ where: {rackZoneMappingId: id }, relations:['rackInfo', 'zoneInfo','endCustomerInfo'] });

        if (responseData) {
            const rack = new RackDropDownDto(responseData.rackInfo.rackId,responseData.rackInfo.rackCode);
            const zone = new ZoneDropDownDto(responseData.zoneInfo.zoneId, responseData.zoneInfo.zoneName);
            const endCustomer = new EndCustomersData(responseData.endCustomerInfo.endCustomerId, responseData.endCustomerInfo.endCustomerName)
            
            const data = new RackZoneEmpData(rack, zone, endCustomer, responseData.isActive, responseData.versionFlag, responseData.rackZoneMappingId);
            return new RackZoneEmpMapResponseModel(true, 7879, 'Data Retrived Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }

    async getRackZone(zoneId: number, rackId:number,endCustomerId:number): Promise<RackZoneMapping> {
        //  console.log(employeeId);
        const response = await this.repository.findOne({
            where: { zoneId :zoneId,rackId:rackId,endCustomerId:endCustomerId},
        });
        // console.log(response);
        if (response) {
            return response;
        } else {
            return null;


        }
    }
    async getRackZoneData(rackZoneMappingId: number): Promise<RackZoneMapping> {
        //  console.log(employeeId);
        const response = await this.repository.findOne({
            where: { rackZoneMappingId: rackZoneMappingId },
        });
        // console.log(response);
        if (response) {
            return response;
        } else {
            return null;


        }
    }


    async getAllRacksByEndCustomer(rackZoneEndCustResponse: RackZoneEndCustResponse): Promise<AllRackZoneMapResponseModel> {
        try{
            const responseDate = await this.repository.find({relations:['rackInfo', 'zoneInfo','endCustomerInfo'], where:{endCustomerId:rackZoneEndCustResponse.endCustomerId}});

            const rackZoneDetails: AllRackZoneMappingDto[] = [];
            if (responseDate.length > 0) {
                responseDate.forEach((rackZone) => {
                    const rackZoneData = new AllRackZoneMappingDto(rackZone.rackInfo.rackId,rackZone.zoneInfo.zoneId,rackZone.rackInfo.rackCode, rackZone.zoneInfo.zoneName, rackZone.endCustomerInfo.endCustomerId, rackZone.endCustomerInfo.endCustomerName, rackZone.isActive, rackZone.versionFlag, rackZone.rackZoneMappingId);
                    rackZoneDetails.push(rackZoneData);
                })
                return new AllRackZoneMapResponseModel(true, 2234, 'RackZone Details Retrived Successfully', rackZoneDetails)
            } else {
                return new AllRackZoneMapResponseModel(false, 1011, 'No Data Found')
            }
        } catch (err) {
            throw err;
        }
    }
    async activateorDeactivateRackZone(RackZoneAct: RackZoneDtoActive): Promise<RackZonemapResponse> {
        try {
            const rackZoneExists = await this.getRackZoneData(RackZoneAct.rackZoneMappingId);
            if (rackZoneExists) {
                if (RackZoneAct.versionFlag !== rackZoneExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current rackZone information.Refresh and try again');
                } else {

                    const rackZoneSatatus = await this.repository.update(
                        { rackZoneMappingId: RackZoneAct.rackZoneMappingId },
                        { isActive: RackZoneAct.isActive, updatedUser: RackZoneAct.updatedUser });
                    const updatedRecord = await this.getRecordByRackZoneMapId(RackZoneAct.rackZoneMappingId);

                    const rackZoneEmpDetails = await this.getRecordByRackZoneMapId(RackZoneAct.rackZoneMappingId);
                    if (rackZoneExists.isActive) {
                        if (rackZoneSatatus.affected) {
                            const rackZoneMapppingResponse: RackZonemapResponse = new RackZonemapResponse(true, 10115, ' is de-activated successfully', rackZoneEmpDetails.data);
                            return rackZoneMapppingResponse;
                        } else {
                            throw new ErrorResponse(10111, 'RackZone is already deactivated');
                        }
                    } else {
                        if (rackZoneSatatus.affected) {
                            const rackZoneResponse: RackZonemapResponse = new RackZonemapResponse(true, 10114, 'Pallet is activated successfully', rackZoneEmpDetails.data);
                            return rackZoneResponse;
                        } else {
                            throw new ErrorResponse(10112, 'RackZone is already  activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }



}
